<template>
    <div class="projectShift-wrap" style="font-size: 12px"
        :data-component-name="$options.name"
    >
        <q-expansion-item
            dense
            dense-toggle
            group="ProjectShift"
            :label="projectShift.name"
            :caption="caption"
            :default-opened="projectShift.opened"
            @before-hide="validateFieldSet($event)"
            @after-hide="clearSelectedShift()"
            ref="expansionItem"
            class=""
        >
            <template v-slot:header>
                <q-item-section>
                    <div class="-header" style="width:100%">
                        <div class="row">
                            <div class="label-style q-mr-auto q-mb-xs" v-html="caption"></div>
                            <div class="label-style hours-caption q-mb-xs" v-html="hours"></div>
                        </div>
                        <div class="-name">
                            <q-icon name="layers" class="is-overwriter" v-if="projectShift.isProjectShiftOverwriter">
                                <q-tooltip v-if="projectShift.overwrittenProjectShift">
                                    <div>Ce quart de travaille remplace le quart de travail «<strong>{{ projectShift.overwrittenProjectShift.name }}</strong>»</div>
                                </q-tooltip>
                            </q-icon>
                            {{ projectShift.name }}
                            <div class="o-item-with-error">
                                <q-icon class="o-item-with-error-icon" v-if="projectShiftWithError[projectShift.id] || projectShiftWithUnassigned[projectShift.id]" name="o_warning_amber">
                                    <q-tooltip>Ce quart de travail contient une ou plusieurs erreurs</q-tooltip>
                                </q-icon>
                                <q-icon class="o-item-with-warning-icon" v-if="projectShift.hasDraft" name="hourglass_bottom">
                                    <q-tooltip>Ce quart de travail des informations non publiées</q-tooltip>
                                </q-icon>
                            </div>
                        </div>
                    </div>
                </q-item-section>
            </template>
            <q-card class="transparent">
                <q-card-section>
                    <!--<Input v-model="projectShift.id" label="id *" :required="true" ref="id"/>-->
                    <Input v-model="projectShift.name" label="Nom *" :required="true" ref="name"/>
                    <Input type="textarea" autogrow light v-model="projectShift.description" label="Description" />
                    <Input v-model="projectShift.start_time" label="Heure de début *" mask="time" :rules="['time']" placeholder="00:00" :required="true" ref="starttime" :disable="accessLevel.isReadOnly" :readonly="accessLevel.isReadOnly" />
                    <Input v-model="projectShift.end_time" label="Heure de fin *" mask="time" :rules="['time']" placeholder="00:00" :required="true" ref="endtime" :disable="accessLevel.isReadOnly" :readonly="accessLevel.isReadOnly" />

                    <DateRangesPicker
                        v-model="projectShift.dates"
                        v-bind:projectShift="projectShift"
                        v-bind:dateFrom="weekrange.obj.from"
                        v-bind:selectedDates="selectedDates"
                        required="true"
                        :range="true"
                        :multiple="true"
                        :disable="accessLevel.isReadOnly"
                        :readonly="accessLevel.isReadOnly" 
                    />
                    <!-- <div class="o-form__item"> -->
                    <q-field
                        filled
                        dense
                        placehoder="Non assigné"
                        label="Jours de la semaine"
                        value="none"
                        icon="add"
                        :bottom-slots="false"
                        class="custom-input-list"
                        :disable="accessLevel.isReadOnly"
                        :readonly="accessLevel.isReadOnly" 
                    >
                        <template v-slot:control>

                            <div class="row full-width items-center justify-center checkbox-group">
                                <input type="checkbox" v-model="projectShift.Sun" label="Di" :id="'dr_sun'+projectShift.id" />
                                <label :for="'dr_sun'+projectShift.id">
                                    D
                                </label>

                                <input type="checkbox" v-model="projectShift.Mon" label="Lu" :id="'dr_mon'+projectShift.id" />
                                <label :for="'dr_mon'+projectShift.id">
                                    L
                                </label>

                                <input type="checkbox" v-model="projectShift.Tue" label="Ma" :id="'dr_tue'+projectShift.id"/>
                                <label :for="'dr_tue'+projectShift.id">
                                    M
                                </label>

                                <input type="checkbox" v-model="projectShift.Wed" label="Me" :id="'dr_wed'+projectShift.id" />
                                <label :for="'dr_wed'+projectShift.id">
                                    M
                                </label>

                                <input type="checkbox" v-model="projectShift.Thu" label="Je" :id="'dr_thu'+projectShift.id" />
                                <label :for="'dr_thu'+projectShift.id">
                                    J
                                </label>

                                <input type="checkbox" v-model="projectShift.Fri" label="Ve" :id="'dr_fri'+projectShift.id" />
                                <label :for="'dr_fri'+projectShift.id">
                                    V
                                </label>

                                <input type="checkbox" v-model="projectShift.Sat" label="Sa" :id="'dr_sat'+projectShift.id" />
                                <label :for="'dr_sat'+projectShift.id">
                                    S
                                </label>
                            </div>
                        </template>
                    </q-field>


                    <UserProfileInput
                        v-model="projectShift.supervisor"
                        label="Superviseur des travaux"
                        class="q-mt-xs"
                    />

                    <!-- </div> -->
                    <div :key="tg" v-for="(tagGroup, tg) in customTagsList">
                        <div class="" v-if="customTagsList.length>0">
                            <q-field
                                filled
                                dense
                                placehoder="Non assigné"
                                :label="tagGroup.label"
                                value="none"
                                icon="add"
                                :bottom-slots="false"
                                class="custom-input-list q-mt-xs"
                            >
                                <template v-slot:control>
                                    <div class="q-field__native items-center full-width input-row" tabindex="0"
                                        :key="t"
                                        v-for="(tag, t) in tagGroup.tags"
                                    >
                                        <div>
                                            {{ tag.name }}
                                        </div>
                                        <q-icon
                                            class="q-field__focusable-action material-icons q-icon notranslate"
                                            size="xs"
                                            name="cancel"
                                            @click="removeCustomTag(tag)"
                                        />
                                    </div>
                                </template> 
                            </q-field>
                        </div>
                    </div>

                    <div :key="'rg'+rg" v-for="(resourceGroup, rg) in resourcesList">
                        <div class="" v-if="resourcesList.length>0">
                            <q-field
                                filled
                                dense
                                placehoder="Non assigné"
                                :label="resourceGroup.type"
                                value="none"
                                icon="add"
                                :bottom-slots="false"
                                class="custom-input-list q-mt-xs"
                            >
                                <template v-slot:control>
                                    <div class="q-field__native items-center full-width input-row" tabindex="0"
                                        :key="t"
                                        v-for="(resource, t) in resourceGroup.resources"
                                    >
                                        <div>
                                            {{ resource.name }}
                                            <div class="o-resource-description" v-if="resource.description && resource.description!=''"><small>{{ resource.description }}</small></div>
                                        </div>
                                        <q-icon
                                            class="q-field__focusable-action material-icons q-icon notranslate"
                                            size="xs"
                                            name="cancel"
                                            @click="removeResource(resource)"
                                        />
                                    </div>
                                </template> 
                            </q-field>
                        </div>
                    </div>

                    <div :key="'sv'+rg" v-for="(resourceGroup, rg) in staffVehiculesList">
                        <div class="" v-if="staffVehiculesList.length>0">
                            <q-field
                                filled
                                dense
                                placehoder="Non assigné"
                                :label="resourceGroup.type"
                                value="none"
                                icon="add"
                                :bottom-slots="false"
                                class="custom-input-list q-mt-xs"
                            >
                                <template v-slot:control>
                                    <div class="q-field__native items-center full-width input-row" tabindex="0"
                                        :key="t"
                                        v-for="(resource, t) in resourceGroup.resources"
                                    >
                                        <div>
                                            {{ resource.userProfile.name + ' : ' + resource.name }}
                                            <div class="o-resource-description" v-if="resource.description && resource.description!=''"><small>{{ resource.description }}</small></div>
                                        </div>
                                        <q-icon
                                            class="q-field__focusable-action material-icons q-icon notranslate"
                                            size="xs"
                                            name="cancel"
                                            @click="removeResource(resource)"
                                        />
                                    </div>
                                </template> 
                            </q-field>
                        </div>
                    </div>

                </q-card-section>
                <q-card-section class="-footer">
                    <div>
                        <ModelCustomTagsMenu 
                            @add-custom-tag="addCustomTag($event)"
                            tagsModel="SHIFTS"
                            label=""
                            icon="playlist_add"
                            :round="true"
                            title="ajouter une information complémentaire"
                            size="xs"
                            color="white"
                            text-color="black"
                        />
                        <AddResourcesMenu 
                            resourcesModel="SHIFTS"
                            label=""
                            icon="add_road"
                            :round="true"
                            title="ajouter une ressource (véhicule, outil, ...)"
                            size="xs"
                            color="white"
                            text-color="black"
                            @add-resource="addResource($event)"
                            :staffVehicules="staffVehicules"
                        />
                            <!-- @add-custom-tag="addCustomTag($event)"
                        /> -->
                    </div>
                    <div>
                        <q-btn
                            round
                            color="white"
                            text-color="black"
                            icon="mail"
                            size="xs"
                            @click.stop="mailTO(projectShift)"
                            title="Envoyer un courriel à l'équipe"
                        />   
                        <q-btn
                            round
                            color="blue"
                            icon="content_copy"
                            size="xs"
                            @click.stop="$emit('duplicate-projectshift', projectShift)"
                            title="Copier le quart de travail"
                            :disable="accessLevel.isReadOnly"
                            :readonly="accessLevel.isReadOnly" 
                        />   
                        <q-btn
                            round
                            color="red"
                            icon="delete"
                            size="xs"
                            @click.stop="$refs.expansionItem.hide(); $emit('remove-projectshift', projectShift)"
                            title="Supprimer le quart de travail"
                            :disable="accessLevel.isReadOnly"
                            :readonly="accessLevel.isReadOnly" 
                        />
                    </div>
                </q-card-section>

            </q-card>
        </q-expansion-item>
        <q-separator />
    </div>
</template>

<script>
    import {getWeeksLimits, dayStr, monthStr} from '@/js/dateUtilities'
    import uniqBy from 'lodash/uniqBy'
    import orderBy from "lodash/orderBy";
    import moment from 'moment';
    import { MYPROFILE } from '@/graphql/user/queries'

    export default {
        name: 'ProjectShift',
        props: {
            expanded: {
                type: Boolean,
                default: false
            },
            projectShift: Object,
            project: Object,
            selectedProjectShift: Object,
            weekrange:{
                type: Object,
                default(){
                    let date=getWeeksLimits(new Date(), this.$generalSettings.settings.firstDayOfWeek);
                    return {
                        ...date
                    }
                }
            },
            projectShiftWithError: Object,
            projectShiftWithUnassigned: Object,
            accessLevel: {
                type: [Object],
                default() {
                    return null
                }
            }
        },
        data(){
            return {
                readMode:true,
            }
        },
        mounted(){
            if(this.projectShift.isNew) {
                this.readMode=false;
            }
        },
        watch: {
            expanded: function(){
                if(this.expanded){
                    this.$refs.expansionItem.show()
                }
                if(!this.expanded){
                    this.$refs.expansionItem.hide()
                }
            }
        },
        computed: {
            staffVehicules(){
                let staffVehicules=[];
                this.projectShift.projectAssignments.forEach(function(assignment){
                    if(assignment.assignedTo && assignment.assignedTo.vehicule_available && assignment.assignedTo.vehicules.length>0){
                        assignment.assignedTo.vehicules.forEach(function(vehicule){
                            // vehicule.name=assignment.assignedTo.name + ' : ' + vehicule.name;
                            staffVehicules.push(vehicule);
                        })
                    }
                })

                return staffVehicules;
            },
            caption(){
                if(!this.minMaxDates || typeof this.minMaxDates.min === 'undefined') return "Sans date"
                let start=new Date(moment(this.minMaxDates.min));
                let end=new Date(moment(this.minMaxDates.max));
                return dayStr(start.getDate()) + ' ' + monthStr(start).short.toLowerCase() + ' ' + start.getFullYear()+ ' au ' + dayStr(end.getDate()) + ' ' + monthStr(end).short.toLowerCase() + ' ' + end.getFullYear()
            },
            hours() {
                if (this.projectShift.start_time && this.projectShift.end_time) return this.projectShift.start_time + ' à ' + this.projectShift.end_time
                return ""
            },
            minMaxDates(){
                 if(!this.projectShift.dates) return null
                 let dates=[];
                 this.projectShift.dates.forEach(function(date){
                     if(date.from) dates.push(date.from);
                     if(date.to) dates.push(date.to);
                     if(typeof date === 'string') dates.push(date);
                 })
                 dates.sort();
                 return {
                     min: dates[0],
                     max: dates[dates.length-1]
                 }

            },
            daysOfWeekStr(){
                let days=new Array();
                if(this.projectShift.Sun) days.push("Di");
                if(this.projectShift.Mon) days.push("Lu");
                if(this.projectShift.Tue) days.push("Ma");
                if(this.projectShift.Wed) days.push("Me");
                if(this.projectShift.Thu) days.push("Je");
                if(this.projectShift.Fri) days.push("Ve");
                if(this.projectShift.Sat) days.push("Sa");

                return days.join(', ');
            },
            selectedDates(){
                if(!this.projectShift.dates) return new Array();
                let dates=Object.assign([], this.projectShift.dates)
                dates.forEach(function(date, index){
                    if(date.from && date.from == date.to) dates[index]=date.from;
                })
                this.setShiftDates(dates);
                return dates.sort(function(a,b){
                    let aDate=a, bDate=b;
                    if(a.from){
                        aDate=a.from
                    }
                    if(b.from){
                        bDate=b.from
                    }
                    return new Date(aDate)-new Date(bDate)
                })
            },
            customTagsList(){
                let customTagsList=[], lastLabel='', lastItem={};
                if(!this.projectShift.customtags) return customTagsList;
                orderBy(this.projectShift.customtags, [item => item.label.name.toLowerCase()]).forEach(function(item){
                    if(lastLabel!=item.label.name){
                        lastItem={
                            label: item.label.name,
                            tags: []
                        }
                        lastItem.tags.push(item)
                        customTagsList.push(lastItem)
                    }else{
                        lastItem.tags.push(item)
                    }
                    
                    lastLabel=item.label.name
                })
                return customTagsList;
            },
            resourcesList(){
                let resourcesList=[], lastType='', lastItem={};
                if(!this.projectShift.resources) return resourcesList;
                orderBy(this.projectShift.resources, [item => item.type.name.toLowerCase()]).forEach(function(item){
                    if(lastType!=item.type.name){
                        lastItem={
                            type: item.type.name,
                            resources: []
                        }
                        lastItem.resources.push(item)
                        resourcesList.push(lastItem)
                    }else{
                        lastItem.resources.push(item)
                    }
                    
                    lastType=item.type.name
                })
                return resourcesList;
            },
            staffVehiculesList(){
                let resourcesList=[], lastType='', lastItem={};
                if(!this.projectShift.staffVehicules) return resourcesList;
                orderBy(this.projectShift.staffVehicules, [item => item.type.name.toLowerCase()]).forEach(function(item){
                    if(lastType!=item.type.name){
                        lastItem={
                            type: item.type.name,
                            resources: []
                        }
                        lastItem.resources.push(item)
                        resourcesList.push(lastItem)
                    }else{
                        lastItem.resources.push(item)
                    }
                    
                    lastType=item.type.name
                })
                return resourcesList;
            }
        },
        methods: {
            log(msg){
                console.log(msg);
            },
            mailTO(){

                let recipients = [];
                this.projectShift.projectAssignments.forEach(function(assignment){
                    if(assignment.assignedTo && assignment.assignedTo.email){
                        recipients.push( assignment.assignedTo.name + ' <' +assignment.assignedTo.email + '>');
                    }
                })

                recipients = recipients.join(', ');
                let description = this.projectShift.description && this.projectShift.description != '' ? ' %0D%0ADescription: ' + this.projectShift.description : '';
                let title = this.myProfile && this.myProfile.title && this.myProfile.title != '' ? ' %0D%0A' + this.myProfile.title : '';
                let me = this.myProfile && this.myProfile.name && this.myProfile.name != '' ? ' %0D%0A' + this.myProfile.name : '';
                let dates = [];
                if(this.projectShift.dates){
                    this.projectShift.dates.forEach(function(date){
                        if(date.from && date.to){
                            dates.push('du ' + date.from + ' au ' + date.to);
                        }else{
                            dates.push(date);
                        }
                    })
                }
                dates = dates.join(', ');
                window.location.href = "mailto:" + recipients + "?subject=" + this.project.name + " - quart de travail " + this.projectShift.name.toLowerCase() + "&body=Bonjour, %0D%0A%0D%0AVoici les informations concernant le quart de travail : %0D%0A%0D%0AProjet : " + this.project.name + "%0D%0ANom : " + this.projectShift.name + description + "%0D%0AHeure de début : " + this.projectShift.start_time + "%0D%0AHeure de fin : " + this.projectShift.end_time + "%0D%0AJours de la semaine : " + this.daysOfWeekStr + "%0D%0ADates : " + dates + "%0D%0A%0D%0AMerci, %0D%0A" + me + title;
            },
            clearSelectedShift(){
                if(this.selectedProjectShift && this.selectedProjectShift.id==this.projectShift.id ){
                    this.$emit('clear-selectedShift');
                }
            },
            async validateFieldSet(e){
                if(!e) return;

                let valid=true;
                if(!this.$refs.name.$children[0].validate()) valid=false;
                if(!this.$refs.starttime.$children[0].validate()) valid=false;
                if(!this.$refs.endtime.$children[0].validate()) valid=false
                if(!valid){
                    this.$refs.expansionItem.show();
                    return
                }
                // this.$emit('clear-selectedShift');
            },
            setShiftDates(dates){
                this.projectShift.dates=dates;
            },
            addCustomTag(tag){
                this.projectShift.customtags.push(tag)
                this.projectShift.customtags=uniqBy(this.projectShift.customtags, "id")
            },
            addResource(resource){
                if(resource.isUserVehicule){
                    this.projectShift.staffVehicules.push(resource)
                    this.projectShift.staffVehicules=uniqBy(this.projectShift.staffVehicules, "id")
                }else{
                    this.projectShift.resources.push(resource)
                    this.projectShift.resources=uniqBy(this.projectShift.resources, "id")
                }
            },
            removeCustomTag(item){
                this.projectShift.customtags=this.projectShift.customtags.filter(obj => obj.id !== item.id)
            },
            removeResource(item){
                if(item.isUserVehicule){
                    this.projectShift.staffVehicules=this.projectShift.staffVehicules.filter(obj => obj.id !== item.id)
                }else{
                    this.projectShift.resources=this.projectShift.resources.filter(obj => obj.id !== item.id)
                }
            },
        },
        apollo: {
            myProfile: {
                query: MYPROFILE,
                fetchPolicy: 'cache-only',
                error(error) {
                    if (error.message) this.$q.notify({ type: 'negative', message: "Oh Oh", caption: error.message });
                },
                update(data) {
                    return data.myProfile;
                }
            },
        }
    }
</script>


<style lang="scss" scoped>
    .project-item {
        border: 1px solid gray;
        padding: 6px;
        margin-bottom:6px;
    }
    .transparent {
        background: transparent;
    }

    .checkbox-group {
        // position: relative;
        // border: 1px solid #027BE3;
        max-width: 250px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 6px 0;

        & input:checked + label {
            background-color: $color-6;
        }
        input {
            background-color: $color-0;
            display:none;
        }
        & label {
            border-radius: 50%;
            text-align: center;
            flex-grow: 0;
            font-size: 0.9em;
            padding: 1px 0px;
            color: white;
            cursor: pointer;
            width:24px;
            height:24px;
            line-height: 24px;
            vertical-align: middle;
        }
    }

    .hours-caption {
        opacity: 0.7;
        // margin-top: 4px;
        // margin-bottom: 4px;
    }

</style>

<style lang="scss">

.q-item__section--main~.q-item__section--side {
    justify-content: center !important;
    padding-right: 16px;
}
</style>
